import { render, staticRenderFns } from "./NotificationIcon.vue?vue&type=template&id=1fe093f6&scoped=true"
import script from "./NotificationIcon.vue?vue&type=script&lang=ts"
export * from "./NotificationIcon.vue?vue&type=script&lang=ts"
import style0 from "./NotificationIcon.vue?vue&type=style&index=0&id=1fe093f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe093f6",
  null
  
)

export default component.exports